import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="package-selection"
export default class extends Controller {
  static targets = ["checkbox"];

  ensureAtLeastOneChecked(event) {
    const changedCheckbox = event.target;
    const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length;

    if (checkedCount === 0) {
      changedCheckbox.checked = true;
    }
  }
}
